<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {LoanRequestOption, SeekingProvisionCapability} from 'src/typings';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import SendLoanRequestButton from './shared/SendLoanRequestButton.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';
    import {pipe} from 'core/utils';
    import {strParams} from 'shared/utils/pipes';

    export let option: LoanRequestOption<SeekingProvisionCapability>;

    const localize = getLocalization();
</script>

<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization ill.provision.RequestByIll */ 'ill.provision.RequestByIll')}
    </strong>

    <LoanOptionPanelBody>
        <div>
            {pipe(localize(/* @kp-localization ill.provision.RequestOnBehalfOfLibraryX */ 'ill.provision.RequestOnBehalfOfLibraryX'), strParams(option.formObject.requester.text))}
        </div>

        <SendLoanRequestButton {option} apiPath="/seekings/create-provided-request">
            {localize(/* @kp-localization ill.provision.SendIllRequest */ 'ill.provision.SendIllRequest')}
        </SendLoanRequestButton>
    </LoanOptionPanelBody>
</KpGenericPanel>